import React, { useState } from "react";
import { X } from "lucide-react";
import SearchableSelect from "./SearchableSelect";

export default function AddUserModal({
  isOpen,
  onClose,
  initialData,
  onSave,
  roles = [],
}) {
  // Form States
  const [name, setName] = useState("");
  const [roleId, setRoleId] = useState("");
  const [position, setPosition] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");

  React.useEffect(() => {
    if (isOpen && initialData) {
      setName(initialData.name || "");
      const currentRole = String(initialData.role || "").toLowerCase();
      const matchedRoleId = initialData.role_id || (currentRole === "superadmin" ? "superadmin" : currentRole === "kasir" ? "kasir" : initialData.role || "");
      setRoleId(matchedRoleId);
      setPosition(initialData.position || "");
      setEmail(initialData.email || "");
      setPhone(initialData.phone || "");
      setPassword(""); // Selalu kosong saat edit
    } else if (isOpen) {
      setName("");
      setRoleId("");
      setPosition("");
      setEmail("");
      setPhone("");
      setPassword("");
    }
  }, [isOpen, initialData]);

  const handleSave = () => {
    onSave({
      id: initialData?.id,
      name,
      role_id: roleId,
      position,
      email,
      phone,
      password,
      status: initialData?.status || "Aktif",
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4 modal-backdrop-enter">
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-lg w-full max-w-lg flex flex-col max-h-[90vh] modal-panel-enter">
        {/* Header */}
        <div className="flex items-center justify-between p-4 bg-teal-600 text-white rounded-t-lg">
          <h2 className="text-lg font-bold">
            {initialData ? "Edit Data Pengguna" : "Tambah Data Pengguna"}
          </h2>
          <button
            onClick={onClose}
            className="text-white hover:text-gray-200 transition">
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4 overflow-y-auto">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Nama Lengkap <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
              placeholder="Contoh: Dahayu Prameswari"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Role Akses <span className="text-red-500">*</span>
            </label>
            <SearchableSelect
              options={roles}
              value={roleId}
              onChange={(value) => setRoleId(value)}
              placeholder="Pilih salah satu data akses pengguna..."
              displayKey="name"
              valueKey="id"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Jabatan Pengguna <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={position}
              onChange={(e) => setPosition(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
              placeholder="Contoh: Staff Kasir"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Alamat Email <span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
              placeholder="Contoh: prameswari@gmail.com"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Nomor Handphone <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
              placeholder="Contoh: 081234567890"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Password {initialData ? "" : <span className="text-red-500">*</span>}
              {initialData && <span className="text-xs text-gray-500 font-normal ml-1">(Kosongkan jika tidak diubah)</span>}
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
              placeholder="Masukkan password akun..."
            />
          </div>
        </div>

        {/* Footer */}
        <div className="p-4 border-t border-gray-200 flex justify-end">
          <button
            onClick={handleSave}
            className="px-6 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 font-medium transition">
            Simpan Data
          </button>
        </div>
      </div>
    </div>
  );
}
